import { Component, forwardRef, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'ticket-list-dialog',
    template: require('./ticket-list-dialog.component.html')
})
export class TicketListDialogComponent {

    thingId: string;
    eventId: string;

    constructor(
        @Inject(forwardRef(() => MatDialogRef)) public dialogRef: MatDialogRef<TicketListDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data
    ) {
        this.thingId = data.thingId;
        this.eventId = data.eventId;
    }

    close(): void {
        this.dialogRef.close();
    }
}